module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES63UC3']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC3']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codinput",
      "name": "coddesc_codinput"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codinput) + "  " + _vm._s(_vm.detail.tab1.desc_codinput))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC3']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.codempid) + "  " + _vm._s(_vm.detail.tab1.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC3']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dtereq",
      "name": "dtereq"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtereq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "desc_codleave",
      "name": "desc_codleave"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codleave))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "deslereq",
      "name": "deslereq"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.deslereq))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC3']['40']) + " - " + _vm._s(_vm.labels['HRES63UC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dteBtw",
      "name": "dteBtw"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtestrt)) + " - " + _vm._s(_vm.setDateOutput(_vm.detail.tab1.dteend)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC3']['50']) + " - " + _vm._s(_vm.labels['HRES63UC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "timBtw",
      "name": "timBtw"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.timstrt) + " - " + _vm._s(_vm.detail.tab1.timend))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC3']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail.tab1.filename !== '' && _vm.detail.tab1.filename !== ' '),
      expression: "detail.tab1.filename !== '' && detail.tab1.filename !== ' '"
    }],
    attrs: {
      "href": _vm.baseURL + _vm.detail.tab1.filepath,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.detail.tab1.filename) + "\n                      ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES63UC4']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab2.codempid) + "  " + _vm._s(_vm.detail.tab2.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddescTypleave",
      "name": "coddescTypleave"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab2.typleave) + " - " + _vm._s(_vm.detail.tab2.desc_typleave))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right detail-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.flgdlemx),
      expression: "detail.tab2.flgdlemx"
    }],
    attrs: {
      "type": "radio",
      "name": "flgdlemx1",
      "value": "Y",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab2.flgdlemx, "Y")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab2, "flgdlemx", "Y")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['50']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.flgdlemx),
      expression: "detail.tab2.flgdlemx"
    }],
    attrs: {
      "type": "radio",
      "name": "flgdlemx2",
      "value": "N",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab2.flgdlemx, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab2, "flgdlemx", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['60']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row entitlement"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "hres63u-tab2-entitlement hres63u-tab2-entitlement-header bg-color-skin border-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement hres63u-tab2-entitlement-header bg-color-skin border-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement hres63u-tab2-entitlement-header bg-color-skin border-color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['90']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row entitlement"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.day1))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.hur1))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.min1))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row entitlement"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.day2))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.hur2))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.min2))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row entitlement"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.day3))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.hur3))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.min3))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row entitlement"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC4']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.day4))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.hur4))]), _vm._v(" "), _c('div', {
    staticClass: "hres63u-tab2-entitlement"
  }, [_vm._v(_vm._s(_vm.detail.tab2.min4))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES63UC5']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC5']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab3.detail.codempid) + "  " + _vm._s(_vm.detail.tab3.detail.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES63UC5']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "dtecycBtw",
      "name": "dtecycBtw"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab3.detail.dtecycst)) + " - " + _vm._s(_vm.setDateOutput(_vm.detail.tab3.detail.dtecycen)))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab3Table,
      "data": _vm.detail.tab3.table
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details4"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRMS55XC1']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('hrms55x', {
    attrs: {
      "callFrom": "hrms55x2",
      "dateWork": _vm.detail.tab1.dtestrt
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bda971d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres63u/detail.vue
// module id = 3969
// module chunks = 1